import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment-timezone';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';

@UntilDestroy()

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent {
  search = '';
  user: any;
  timeZone: any;
  searchDate: any;
  notifications = [];
  category = '';
  categoryTabs = [
    { value: '', label: 'All' },
    { value: 'ticket', label: 'Tickets' },
    { value: 'other', label: 'Others' },
  ];
  totalPages = 0;
  totalResults = 0;
  currentPage: number = 1
  numberOfRecords = NUMBER_OF_RECORDS;
  constructor(
    private sharedDataService: SharedDataService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.getUser();
    this.getNotifications(this.currentPage = 1);
  }

  getNotifications(page: any) {
    const queryParams: any = {
      sortBy: 'createdAt:desc',
      time: this.searchDate,
      limit: 50,
      page,
    };
    if (this.category) {
      queryParams.category = this.category;
    }
    this.sharedDataService
      .getNotifications(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
          this.notifications = data.results;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      }, err => {
        // sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe(data => {
      if (data) {
        this.user = data;
        this.timeZone = this.user.timeZone;
        const startOfToday = this.timeZone ? moment.tz(this.timeZone).startOf('day').toISOString() : moment().startOf('day').toISOString();
        const endOfToday = this.timeZone ? moment.tz(this.timeZone).endOf('day').toISOString() : moment().endOf('day').toISOString();
        this.searchDate = [startOfToday, endOfToday];
      }
    })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getNotifications(page);
  }

  onSelectCategory(category: string) {
    this.category = category;
    this.getNotifications(this.currentPage = 1);
  }

  onSearchDateChange(event: any) {
    this.searchDate = [
      event[0].toISOString(),
      event[1].endOf("day").toISOString(),
    ];
    this.getNotifications(this.currentPage = 1);
  }

  onNotificationClick(notification: any) {
    this.markAsRead(notification);
    // a support reply opens its ticket or chat
    if (notification.type === 'support' && notification.metadata?.url) {
      this.router.navigateByUrl(notification.metadata.url);
      return;
    }
    if (notification.type === 'trip') {
      this.goToTrips(notification);
    }
    else {
      this.goToOnboarding(notification);
    }
  }

  onMarkSingleAsRead(event: MouseEvent, notification: any) {
    event.stopPropagation();
    this.markAsRead(notification);
  }

  onMarkAllAsRead() {
    this.sharedDataService.markAllAsRead(this.user?.company).subscribe({
      next: () => {
        if (Array.isArray(this.notifications)) {
          this.notifications.forEach((n: any) => n.isRead = true);
        }
        this.sharedDataService.refreshUnreadNotificationCount(true);
      },
      error: () => {}
    });
  }

  hasUnreadNotifications(): boolean {
    return Array.isArray(this.notifications) && this.notifications.some((n: any) => !n.isRead);
  }

  markAsRead(notification: any) {
    if (!notification || notification.isRead) {
      return;
    }
    notification.isRead = true;
    this.sharedDataService.decrementUnreadNotificationCount(1);

    // Not piped through untilDestroyed: a click can navigate away
    // (goToTrips/goToOnboarding), which destroys this component and would
    // otherwise cancel the in-flight request before the server sees it.
    this.sharedDataService
      .markNotificationAsRead(notification.id || notification._id)
      .subscribe({
        next: () => {},
        error: () => {}
      });
  }

  goToTrips(notification: any) {
    this.router.navigate(['trips'], { fragment: notification?.trip?.status });
  }

  goToOnboarding(notification: any) {
    const { type, driver, vehicle, company, signup, member } = notification;
    if (signup) {
      this.router.navigate(['signups']);
      return;
    }
    if (member) {
      this.router.navigate(['members']);
      return;
    }
    let companyId;
    let entityType;
    let entity;
    if (driver) {
      companyId = driver.company;
      entityType = 'drivers';
      entity = driver;
    } else if (vehicle) {
      companyId = vehicle.company;
      entityType = 'vehicles';
      entity = vehicle;
    } else if (company) {
      companyId = company.id;
      entityType = 'company';
      entity = company;
    }
    if (companyId) {
      const redirect = {
        entityType,
        entity
      };
      this.sharedDataService.setOnboardingRedirectEntity(redirect);
      this.router.navigate(['credentials', companyId], { 
        fragment: entityType 
      });
    }
  }

  getEntityType(notification: any) {
    const { driver, vehicle, company, trip, signup, member } = notification;
    let entityType;
    if (driver) {
      entityType = 'drivers';
    } else if (vehicle) {
      entityType = 'vehicles';
    } else if (trip) {
      entityType = 'trip';
    } else if (company) {
      entityType = 'company';
    } else if (signup) {
      entityType = 'signup';
    } else if (member) {
      entityType = 'member';
    }
    return entityType;
  }

  getRelativeTime(date: any): string {
    return date ? moment(date).fromNow() : '';
  }

  ngOnDestroy(): void {
  }
}
